<div class="fast-checkin-duration-container">
  <div class="content-wrapper">
    @if(showError) {
      <div class="row">
        <div class="col-12">
          <div class="alert alert-danger text-center" role="alert">
            {{ errorMessage | translate }}
          </div>
        </div>
      </div>
    }
    @if(sessionInfo) {
      <div class="row">
        <div class="col-12">
          <div class="alert alert-warning" role="alert">
            {{ 'i18n.domain.fast-checkin-session.session-needs-visitor-validation' | translate }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between">
            <strong>{{ 'i18n.domain.fast-checkin-session.validation-until' | translate }}</strong>
            <strong>{{ sessionInfo.visitorSessionToValidateUntil?.toFormat('HH:mm') }}</strong>
          </div>
        </div>
      </div>
      <div class="mb-2">
        <app-barcode-scanner [useInternalValidation]="false"
                        (dataScanned)="onQrScanned($event)"
                        (cameraError)="showQrText = false"
                        (cameraStarted)="showQrText = true">
        </app-barcode-scanner>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-row row">
            <div class="form-group col-md-12">
              <div class="d-flex justify-content-between">
                <span class="text-muted">{{ 'i18n.shared.fields.zone' | translate }}</span>
                <strong>{{ sessionInfo.zone?.name }}</strong>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-muted">{{ 'i18n.shared.fields.control-plate' | translate }}</span>
                <strong>{{ sessionInfo.controlPlateNumber }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="button-container">
      <div class="d-grid">
        <button class="btn btn-danger" (click)="checkOut.emit()">
          {{ 'i18n.domain.fast-checkin-session.close-session' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
